<template>
  <section class="configurar" :class="{ mostrar: storeEditar.mostrarConfiguracoes }">
    <div class="opcoes">
      <h3>Área de Membros</h3>
      <button :class="{ ativo: state.abaAtiva === 'informacoes' }" @click="mudarAba('informacoes')">
        <Svgs nome="cursor" />
        <p>Informações gerais</p>
      </button>
      <button :class="{ ativo: state.abaAtiva === 'dominio' }" @click="mudarAba('dominio')">
        <Svgs nome="dominio" />
        <p>Domínio e URL</p>
      </button>
      <button :class="{ ativo: state.abaAtiva === 'pagamentos' }" @click="mudarAba('pagamentos')">
        <Svgs nome="dinheiro" />
        <p>Pagamentos</p>
      </button>
      <button :class="{ ativo: state.abaAtiva === 'pixel' }" @click="mudarAba('pixel')">
        <Svgs nome="meta" />
        <p>Pixel do Facebook</p>
      </button>
      <button :class="{ ativo: state.abaAtiva === 'gtm' }" @click="mudarAba('gtm')">
        <Svgs nome="google" />
        <p>Google Tag Manager</p>
      </button>
      <button :class="{ ativo: state.abaAtiva === 'seo' }" @click="mudarAba('seo')">
        <Svgs nome="lupa" />
        <p>SEO da Área</p>
      </button>
    </div>
    <div class="conteudo">
      <!-- Informações -->
      <div class="parte" v-show="state.abaAtiva === 'informacoes'">
        <div class="titulo">
          <div class="icone">
            <Svgs nome="cursor" />
          </div>
          <div class="nome">
            <h3>Informações Gerais</h3>
            <p>Área criada {{ helperTexto.formatarData(storeAreas.area?.dataRegistro) }}</p>
          </div>
        </div>
        <Campo tipo="text" placeholder="Ex: LP para Lançamento" completar="false" label="Nome" v-model="state.nome" />
        <Campo tipo="text" placeholder="Ex: Página que será usada para meu lançamento" completar="false" label="Descrição" v-model="state.descricao" />
        <Campo tipo="text" placeholder="sua-landing-page" completar="false" label="URL mber.live/" v-model="state.hotlinkNovo" />
        <Imagem label="Capa da Landing Page" tamanho="Recomendado 640x360" v-model:url="state.capa" :imagemPreenchida="state.capa" />
        <BotaoPrincipal nome="Salvar Informações" :disabled="state.salvandoInformacoes" @click="salvarInformacoes()" />
      </div>
      <!-- Pagamentos -->
      <div class="parte" v-show="state.abaAtiva === 'pagamentos'">
        <DivPagamentos />
      </div>
      <!-- Domínio -->
      <div class="parte" v-show="state.abaAtiva === 'dominio'">
        <div class="titulo">
          <div class="icone">
            <Svgs nome="dominio" />
          </div>
          <div class="nome">
            <h3>Configurar Domínio</h3>
            <p>Sua URL padrão é mber.live/{{ storeAreas.area?.hotlink }}</p>
          </div>
        </div>
        <div class="configurar">
          <!-- Etapa 1: Escolher tipo -->
          <div v-if="state.dominioEtapa === 'tipo'">
            <div class="etapa">
              <div class="nome">
                <div class="icone">
                  <h3>1</h3>
                </div>
                <p>Escolha o formato do domínio</p>
              </div>
              <div class="tipos">
                <button :class="{ ativo: state.dominio.tipo === 'principal' }" @click="selecionarTipo('principal')">seudominio.com</button>
                <button :class="{ ativo: state.dominio.tipo === 'subdominio' }" @click="selecionarTipo('subdominio')">subdominio.seudominio.com</button>
              </div>
            </div>
          </div>
          <!-- Etapa 2: Preencher domínio -->
          <div v-else-if="state.dominioEtapa === 'preencher'">
            <div class="etapa">
              <div class="nome">
                <div class="icone">
                  <h3>2</h3>
                </div>
                <p>Preencha seu domínio</p>
              </div>
              <div class="campos">
                <template v-if="state.dominio.tipo === 'principal'">
                  <Campo tipo="text" placeholder="seudominio.com" completar="false" label="Domínio" v-model="state.dominio.principal" />
                </template>
                <template v-else-if="state.dominio.tipo === 'subdominio'">
                  <Campo tipo="text" placeholder="sub" completar="false" label="Subdomínio" v-model="state.dominio.sub" />
                  <p>.</p>
                  <Campo tipo="text" placeholder="seudominio.com" completar="false" label="Domínio" v-model="state.dominio.principal" />
                </template>
              </div>
              <div class="botoes">
                <BotaoSecundario cor="azul" tamanho="metade" nome="Continuar" @click="confirmarPreenchimento()" />
                <BotaoSecundario cor="cinza" tamanho="metade" nome="Mudar formato" @click="voltarParaTipo()" />
              </div>
            </div>
          </div>
          <!-- Etapa 3: Configurar DNS -->
          <div v-else-if="state.dominioEtapa === 'dns'">
            <div class="etapa">
              <div class="nome">
                <div class="icone">
                  <h3>3</h3>
                </div>
                <p>Configure seu DNS</p>
              </div>
              <div class="tutorial">
                <p>Adicione um registro A em seu domínio com os dados abaixo</p>
                <div class="itens">
                  <div class="item">
                    <h3>Tipo</h3>
                    <h4>A</h4>
                  </div>
                  <div class="item">
                    <h3>Nome</h3>
                    <h4 v-if="!state.dominio.sub">@</h4>
                    <h4 v-else>{{ state.dominio.sub }}</h4>
                  </div>
                  <div class="item">
                    <h3>Valor</h3>
                    <h4>104.248.58.128</h4>
                  </div>
                  <div class="item">
                    <h3>TTL</h3>
                    <h4>1000 ou menor</h4>
                  </div>
                </div>
              </div>
              <div class="botoes">
                <BotaoSecundario cor="azul" tamanho="metade" nome="Registro A criado" @click="iniciarVerificacao()" />
                <BotaoSecundario cor="cinza" tamanho="metade" nome="Alterar domínio" @click="voltarParaPreencher()" />
              </div>
            </div>
          </div>
          <!-- Etapa 4: Verificando DNS -->
          <div v-else-if="state.dominioEtapa === 'verificando'">
            <div class="etapa">
              <div class="nome">
                <div class="icone">
                  <h3>4</h3>
                </div>
                <p>Verificando DNS</p>
              </div>
              <div class="aguardar">
                <p>Consultando registro DNS do seu domínio, aguarde!</p>
                <div class="icone">
                  <span></span>
                  <h3>{{ formatTime(state.dnsCountdown) }}</h3>
                </div>
              </div>
              <div class="botoes">
                <BotaoSecundario cor="cinza" tamanho="inteiro" nome="Cancelar" @click="cancelarVerificacao()" />
              </div>
            </div>
          </div>
          <!-- Etapa 5: Erro na verificação -->
          <div v-else-if="state.dominioEtapa === 'erro'">
            <div class="etapa">
              <div class="nome">
                <div class="icone">
                  <h3>!</h3>
                </div>
                <p>Erro na verificação</p>
              </div>
              <div class="erro">
                <p>Houve um erro ao verificar seu registro A</p>
                <div class="possivel">
                  <Svgs nome="atencao" />
                  <h3>Apague o registro A e recrie com atenção aos dados</h3>
                </div>
                <div class="possivel">
                  <Svgs nome="atencao" />
                  <h3>Confira se há outro registro A ativo no domínio</h3>
                </div>
                <div class="possivel">
                  <Svgs nome="atencao" />
                  <h3>Verifique se o domínio foi digitado corretamente</h3>
                </div>
                <div class="possivel">
                  <Svgs nome="atencao" />
                  <h3>Refaça o processo e, se necessário, tente novamente em 1 hora</h3>
                </div>
              </div>
              <div class="botoes">
                <BotaoSecundario cor="azul" tamanho="metade" nome="Tentar novamente" @click="retryVerificacao()" />
                <BotaoSecundario cor="cinza" tamanho="metade" nome="Fechar" @click="voltarParaPreencher()" />
              </div>
            </div>
          </div>
          <!-- Etapa 6: Sucesso -->
          <div v-else-if="state.dominioEtapa === 'sucesso'">
            <div class="etapa">
              <div class="sucesso">
                <p>Seu domínio está salvo como</p>
                <div class="link">
                  <Svgs nome="link" />
                  <h3>{{ storeAreas.area?.dominioPersonalizado }}</h3>
                </div>
              </div>
              <div class="tutorial">
                <p>Seu registro A desse domínio</p>
                <div class="itens">
                  <div class="item">
                    <h3>Tipo</h3>
                    <h4>A</h4>
                  </div>
                  <div class="item">
                    <h3>Nome</h3>
                    <h4>@</h4>
                  </div>
                  <div class="item">
                    <h3>Valor</h3>
                    <h4>104.248.58.128</h4>
                  </div>
                  <div class="item">
                    <h3>TTL</h3>
                    <h4>1000 ou menor</h4>
                  </div>
                </div>
              </div>
              <div class="botoes" v-if="!state.deletarConfirm">
                <BotaoSecundario cor="vermelho" tamanho="inteiro" nome="Excluir domínio" @click="state.deletarConfirm = true" />
              </div>
              <div class="botoes" v-else>
                <BotaoSecundario cor="vermelho" tamanho="metade" nome="Confirmar exclusão" @click="confirmarExclusao()" />
                <BotaoSecundario cor="cinza" tamanho="metade" nome="Cancelar" @click="cancelarExclusao()" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Pixel -->
      <div class="parte" v-show="state.abaAtiva === 'pixel'">
        <div class="titulo">
          <div class="icone">
            <Svgs nome="meta" />
          </div>
          <div class="nome">
            <h3>Pixel do Facebook</h3>
            <p>Configure seu pixel para rastreamento</p>
          </div>
        </div>
        <Campo tipo="text" placeholder="XXXXXXXXXXX" completar="false" label="ID do seu Pixel" v-model="state.pixelFacebook.id" @paste="handlePixelIdPaste" />
        <Campo tipo="text" placeholder="PageView" completar="false" label="Evento do Pixel" v-model="state.pixelFacebook.evento" @paste="handlePixelEventoPaste" />
        <BotaoPrincipal nome="Salvar Pixel" :disabled="state.salvandoPixel" @click="salvarPixel()" />
      </div>
      <!-- GTM -->
      <div class="parte" v-show="state.abaAtiva === 'gtm'">
        <div class="titulo">
          <div class="icone">
            <Svgs nome="google" />
          </div>
          <div class="nome">
            <h3>Google Tag Manager</h3>
            <p>Configure seu container GTM</p>
          </div>
        </div>
        <Campo tipo="text" placeholder="GTM-XXXXXXXXX" completar="false" label="ID do seu Google Tag Manager" v-model="state.tagManager" />
        <BotaoPrincipal nome="Salvar Tag" :disabled="state.salvandoGoogle" @click="salvarGoogle()" />
      </div>
      <!-- SEO -->
      <div class="parte" v-show="state.abaAtiva === 'seo'">
        <div class="titulo">
          <div class="icone">
            <Svgs nome="lupa" />
          </div>
          <div class="nome">
            <h3>Otimização para Busca</h3>
            <p>Configure o SEO da sua página</p>
          </div>
        </div>
        <div class="previa">
          <Svgs class="google" nome="google-colorido" />
          <div class="nome">
            <div class="icone" :style="`background-image: url(${state.metatags.favicon})`"></div>
            <div class="texto">
              <h3>{{ state.nome }}</h3>
              <p v-if="storeAreas.area?.dominioPersonalizado">{{ storeAreas.area?.dominioPersonalizado }}</p>
              <p v-else>mber.live/{{ storeAreas.area?.hotlink }}</p>
            </div>
          </div>
          <div class="info">
            <h3>{{ state.metatags.titulo }}</h3>
            <p>{{ state.metatags.descricao }}</p>
          </div>
        </div>
        <Imagem label="Favicon" tamanho="Recomendado 300x300" v-model:url="state.metatags.favicon" :imagemPreenchida="state.metatags.favicon" />
        <BotaoPrincipal nome="Salvar SEO" :disabled="state.salvandoMetatags" @click="salvarMetatags()" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive, watch, inject, onMounted, onUnmounted } from 'vue'
import { useStoreEditar, useStoreAreas, useStoreDominios } from '@stores'
import { helperTexto } from '@helpers'
import Svgs from '@svgs'
import BotaoPrincipal from '@/components/global/elementos/BotaoPrincipal.vue'
import BotaoSecundario from '@/components/global/elementos/BotaoSecundario.vue'
import Campo from '@/components/global/elementos/Campo.vue'
import Imagem from '@/components/global/elementos/Imagem.vue'
import DivPagamentos from '@/components/editar/configuracoes/DivPagamentos.vue'

const storeEditar = useStoreEditar()
const storeAreas = useStoreAreas()
const storeDominios = useStoreDominios()
const emitter = inject('emitter')

const state = reactive({
  nome: '',
  descricao: '',
  hotlinkNovo: '',
  hotlinkOriginal: '',
  capa: '',
  metatags: {
    titulo: '',
    descricao: '',
    favicon: ''
  },
  pixelFacebook: {
    id: '',
    evento: ''
  },
  tagManager: '',
  dominio: {
    tipo: '',
    sub: '',
    principal: '',
    rota: ''
  },
  salvandoInformacoes: false,
  salvandoMetatags: false,
  salvandoPixel: false,
  salvandoGoogle: false,
  salvandoDominio: false,
  abaAtiva: 'informacoes',
  dominioEtapa: '',
  dnsCountdown: 300,
  deletarConfirm: false,
  countdownTimer: null
})

function mudarAba(aba) {
  state.abaAtiva = aba
}

function carregarDados() {
  state.nome = storeAreas.area?.nome
  state.descricao = storeAreas.area?.descricao
  state.hotlinkNovo = storeAreas.area?.hotlink
  state.hotlinkOriginal = storeAreas.area?.hotlink
  state.capa = storeAreas.area?.imagemCapa
  state.metatags.titulo = storeAreas.area?.metatags?.titulo
  state.metatags.descricao = storeAreas.area?.metatags?.descricao
  state.metatags.favicon = storeAreas.area?.metatags?.favicon
  state.tagManager = storeAreas.area?.integracoes?.tagManager?.id
  state.pixelFacebook.id = storeAreas.area?.integracoes?.facebook?.id
  state.pixelFacebook.evento = storeAreas.area?.integracoes?.facebook?.evento

  if (storeAreas.area?.dominioPersonalizado) {
    state.dominioEtapa = 'sucesso'
    state.dominio.principal = storeAreas.area?.dominioPersonalizado
  } else {
    state.dominioEtapa = 'tipo'
  }
}

function formatarHotlink(valor) {
  return valor
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '')
}

watch(
  () => state.hotlinkNovo,
  (novoValor) => {
    if (novoValor) {
      state.hotlinkNovo = formatarHotlink(novoValor)
    }
  }
)

async function salvarInformacoes() {
  state.salvandoInformacoes = true

  const hotlinkAlterado = state.hotlinkOriginal !== state.hotlinkNovo

  const idArea = storeAreas.area._id

  const payload = {
    nome: state.nome,
    descricao: state.descricao,
    imagemCapa: state.capa
  }

  if (hotlinkAlterado) payload.hotlink = state.hotlinkNovo

  const edicaoOk = await storeAreas.alterarDados(idArea, payload)
  if (edicaoOk !== true) return

  if (hotlinkAlterado) {
    window.location.assign('/editar/' + state.hotlinkNovo)
  } else {
    emitter.emit('atualizarArea')
    emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Informações alteradas com sucesso!' })
    storeEditar.mostrarConfiguracoes = false
    state.salvandoInformacoes = false
  }
}

async function salvarGoogle() {
  state.salvandoGoogle = true

  const idArea = storeAreas.area._id

  const payload = {
    integracoes: {
      tagManager: {
        id: state.tagManager
      }
    }
  }

  const edicaoOk = await storeAreas.alterarDados(idArea, payload)
  if (edicaoOk !== true) return

  emitter.emit('atualizarArea')
  emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Google Tag Manager salvo com sucesso!' })
  storeEditar.mostrarConfiguracoes = false
  state.salvandoGoogle = false
}

function extrairPixelFacebook(codigo) {
  try {
    if (!codigo || !codigo.includes("fbq('init'") || !codigo.includes("fbq('track'")) {
      return false
    }

    const regexId = /fbq\('init',\s*'(\d+)'\)/i
    const matchId = codigo.match(regexId)

    const regexIdAlt = /fbq\('init',\s*"(\d+)"\)/i
    const matchIdAlt = !matchId ? codigo.match(regexIdAlt) : null

    const regexIdLetras = /fbq\('init',\s*'([a-zA-Z0-9]+)'\)/i
    const matchIdLetras = !matchId && !matchIdAlt ? codigo.match(regexIdLetras) : null

    const regexIdLetrasAlt = /fbq\('init',\s*"([a-zA-Z0-9]+)"\)/i
    const matchIdLetrasAlt = !matchId && !matchIdAlt && !matchIdLetras ? codigo.match(regexIdLetrasAlt) : null

    const regexEvento = /fbq\('track',\s*'([^']+)'\)/i
    const matchEvento = codigo.match(regexEvento)

    const regexEventoAlt = /fbq\('track',\s*"([^"]+)"\)/i
    const matchEventoAlt = !matchEvento ? codigo.match(regexEventoAlt) : null

    const pixelId = matchId?.[1] || matchIdAlt?.[1] || matchIdLetras?.[1] || matchIdLetrasAlt?.[1]
    const pixelEvento = matchEvento?.[1] || matchEventoAlt?.[1]

    if (pixelId) {
      state.pixelFacebook.id = pixelId
    }

    if (pixelEvento) {
      state.pixelFacebook.evento = pixelEvento
    }

    if (pixelId || pixelEvento) {
      emitter.emit('mostrarAlerta', {
        tipo: 'positivo',
        mensagem: 'Código do Pixel extraído com sucesso!'
      })
      return true
    }

    return false
  } catch (error) {
    console.error('Erro ao extrair dados do pixel:', error)
    return false
  }
}

function handlePixelIdPaste(event) {
  const clipboardData = event.clipboardData || window.clipboardData
  const textoColado = clipboardData.getData('text')

  if (textoColado.includes('<!-- Meta Pixel Code -->') || textoColado.includes("fbq('init'") || textoColado.includes('fbq("init"')) {
    event.preventDefault()
    const extraido = extrairPixelFacebook(textoColado)

    if (!extraido) {
      state.pixelFacebook.id = textoColado
    }
  }
}

function handlePixelEventoPaste(event) {
  const clipboardData = event.clipboardData || window.clipboardData
  const textoColado = clipboardData.getData('text')

  if (textoColado.includes('<!-- Meta Pixel Code -->') || textoColado.includes("fbq('init'") || textoColado.includes('fbq("init"')) {
    event.preventDefault()
    const extraido = extrairPixelFacebook(textoColado)

    if (!extraido) {
      state.pixelFacebook.evento = textoColado
    }
  }
}

async function salvarPixel() {
  state.salvandoPixel = true

  const idArea = storeAreas.area._id

  const payload = {
    integracoes: {
      facebook: {
        id: state.pixelFacebook.id,
        evento: state.pixelFacebook.evento
      }
    }
  }

  const edicaoOk = await storeAreas.alterarDados(idArea, payload)
  if (edicaoOk !== true) return

  emitter.emit('atualizarArea')
  emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Pixel salvo com sucesso!' })
  storeEditar.mostrarConfiguracoes = false
  state.salvandoPixel = false
}

async function salvarMetatags() {
  state.salvandoMetatags = true

  const idArea = storeAreas.area._id

  const payload = {
    metatags: {
      favicon: state.metatags?.favicon
    }
  }

  const edicaoOk = await storeAreas.alterarDados(idArea, payload)
  if (edicaoOk !== true) return

  emitter.emit('atualizarArea')
  emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'SEO salvo com sucesso!' })
  storeEditar.mostrarConfiguracoes = false
  state.salvandoMetatags = false
}

watch(
  () => storeAreas.area,
  (novoValor) => {
    if (novoValor) {
      carregarDados()
    }
  },
  { immediate: true }
)

function selecionarTipo(tipo) {
  state.dominio.tipo = tipo
  state.dominio.sub = ''
  state.dominio.principal = ''
  state.dominio.rota = ''
  state.dominioEtapa = 'preencher'
}

function voltarParaTipo() {
  state.dominioEtapa = 'tipo'
}

function confirmarPreenchimento() {
  if (state.dominio.tipo === 'principal' && !state.dominio.principal) {
    emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: 'Preencha o domínio' })
    return
  }
  if (state.dominio.tipo === 'subdominio' && (!state.dominio.sub || !state.dominio.principal)) {
    emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: 'Preencha subdomínio e domínio' })
    return
  }
  if (state.dominio.tipo === 'rota' && (!state.dominio.principal || !state.dominio.rota)) {
    emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: 'Preencha domínio e rota' })
    return
  }
  state.dominioEtapa = 'dns'
}

function voltarParaPreencher() {
  state.dominioEtapa = 'preencher'
}

function formatTime(seconds) {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`
}

function iniciarVerificacao() {
  state.dnsCountdown = 300
  state.dominioEtapa = 'verificando'
  startCountdown()
}

function startCountdown() {
  clearInterval(state.countdownTimer)
  state.countdownTimer = setInterval(async () => {
    state.dnsCountdown--
    if (state.dnsCountdown % 30 === 0) {
      await verificarRegistroA()
    }
    if (state.dnsCountdown <= 0) {
      clearInterval(state.countdownTimer)
      state.dominioEtapa = 'erro'
    }
  }, 1000)
}

async function verificarRegistroA() {
  let domain = ''
  if (state.dominio.tipo === 'principal') {
    domain = state.dominio.principal
  } else if (state.dominio.tipo === 'subdominio') {
    domain = `${state.dominio.sub}.${state.dominio.principal}`
  } else if (state.dominio.tipo === 'rota') {
    domain = state.dominio.principal
  }
  const valid = await storeDominios.validarDominioDNS(domain)
  if (valid) {
    clearInterval(state.countdownTimer)
    const payload = {
      dominioPersonalizado: state.dominio.tipo === 'subdominio' ? `${state.dominio.sub}.${state.dominio.principal}` : state.dominio.principal,
      idArea: storeAreas.area._id
    }
    const dominioAlteradoOk = await storeAreas.alterarDominio(payload)
    if (dominioAlteradoOk) {
      emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Domínio configurado com sucesso!' })
      emitter.emit('atualizarArea')
      state.dominioEtapa = 'sucesso'
    }
  }
}

function cancelarVerificacao() {
  clearInterval(state.countdownTimer)
  state.dnsCountdown = 300
  state.dominioEtapa = 'preencher'
}

function retryVerificacao() {
  state.dnsCountdown = 300
  state.dominioEtapa = 'verificando'
  startCountdown()
}

async function confirmarExclusao() {
  const payload = { idArea: storeAreas.area?._id }
  const dominioRemovidoOk = await storeAreas.removerDominio(payload)
  if (dominioRemovidoOk) {
    emitter.emit('atualizarArea')
    emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Domínio removido com sucesso!' })
    state.dominioEtapa = 'tipo'
  }
}

function cancelarExclusao() {
  state.deletarConfirm = false
}

onMounted(() => {
  emitter.on('carregarCampos', carregarDados)
})

onUnmounted(() => {
  clearInterval(state.countdownTimer)
})
</script>

<style scoped>
section.configurar {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  position: fixed;
  top: -100dvh;
  left: 0;
  width: 100%;
  height: calc(100dvh - 60px);
  background-color: var(--cor-escuro-1);
  overflow-y: scroll;
  scrollbar-width: none;
  z-index: 5;
  transition: all 0.8s;
}
section.configurar::-webkit-scrollbar {
  display: none;
}
section.configurar.mostrar {
  top: 60px;
}
section.configurar.mostrar .opcoes {
  left: 0;
}
.opcoes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: fixed;
  top: 62px;
  left: -320px;
  width: 320px;
  height: 100%;
  background-color: var(--cor-escuro-2);
  border-right: 2px solid var(--cor-escuro-3);
  padding: 15px;
  transition: all 0.5s;
}
.opcoes h3 {
  font-family: var(--medium);
  font-size: var(--f1);
  color: var(--cor-branco);
  margin: 0 0 10px 0;
}
.opcoes button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 15px 12px;
  background-color: var(--cor-escuro-3);
  border-radius: 8px;
  margin: 5px 0 0 0;
  transition: all 0.3s;
}
.opcoes button.ativo {
  background-color: var(--cor-escuro-4);
}
.opcoes button.ativo:hover svg {
  fill: var(--cor-branco);
}
.opcoes button.ativo:hover p {
  color: var(--cor-branco);
}
.opcoes button.ativo svg {
  fill: var(--cor-branco);
}
.opcoes button.ativo p {
  color: var(--cor-branco);
}
.opcoes button:hover svg {
  fill: var(--cor-branco);
}
.opcoes button:hover p {
  color: var(--cor-branco);
}
.opcoes button svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-escuro-6);
  margin: 0 8px 0 0;
  transition: all 0.3s;
}
.opcoes button p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 320px);
  padding: 30px;
}
.conteudo .parte {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  border: 2px solid var(--cor-escuro-3);
  padding: 30px;
  border-radius: 8px;
  animation: fadeIn 0.3s linear;
}
.conteudo .parte .titulo {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 0 15px 0;
}
.conteudo .parte .titulo .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: var(--cor-escuro-3);
  margin: 0 10px 0 0;
}
.conteudo .parte .titulo .icone svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-6);
}
.conteudo .parte .titulo .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.conteudo .parte .titulo .nome h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.conteudo .parte .titulo .nome p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  margin: 5px 0 0 0;
}
.conteudo .parte .imagem {
  margin: 0 0 10px 0;
}
.conteudo .parte .campo {
  margin: 0 0 10px 0;
}
.conteudo .parte button.principal {
  margin: 10px 0 0 0;
}
.conteudo .parte .previa {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border-radius: 8px;
  background-color: var(--cor-branco-fixo);
  margin: 0 0 10px 0;
  position: relative;
}
.conteudo .parte .previa svg.google {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  min-width: 30px;
}
.conteudo .parte .previa .nome {
  display: flex;
  align-items: center;
  padding: 15px 15px 0 15px;
}
.conteudo .parte .previa .nome .icone {
  width: 30px;
  height: 30px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 8px 0 0;
}
.conteudo .parte .previa .nome h3 {
  font-family: var(--bold);
  font-size: var(--f1);
  color: #202124;
}
.conteudo .parte .previa .nome p {
  font-family: var(--regular);
  font-size: var(--f0);
  color: #4d5155;
  margin: 3px 0 0 0;
}
.conteudo .parte .previa .info {
  width: 100%;
  padding: 10px 15px 5px 15px;
}
.conteudo .parte .previa .info h3 {
  font-family: var(--regular);
  font-size: var(--f3);
  color: #1a0dab;
  line-height: 1.3;
}
.conteudo .parte .previa .info p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: #767676;
  line-height: 1.3;
}
.conteudo .parte .tema {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 10px 0 20px 0;
}
.conteudo .parte .tema .imagem {
  width: 100%;
  max-width: 400px;
  margin: 0 20px 0 0;
  position: relative;
}
.conteudo .parte .tema .imagem span {
  position: absolute;
  top: 10px;
  left: 5px;
  width: calc(100% - 10px);
  height: 45px;
  border-radius: 25px 25px 0 0;
  z-index: 1;
}
.conteudo .parte .tema .imagem img {
  width: 100%;
  position: relative;
  z-index: 2;
}
.conteudo .parte .tema h3 {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-branco);
  margin: 0 0 10px 0;
}
.conteudo .parte .configurar {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.conteudo .parte .configurar .etapa {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.conteudo .parte .configurar .etapa .botoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 10px 0 0 0;
}
.conteudo .parte .configurar .etapa .nome {
  display: flex;
  align-items: center;
  margin: 0 0 15px 0;
}
.conteudo .parte .configurar .etapa .nome .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background-color: var(--cor-escuro-4);
  margin: 0 10px 0 0;
}
.conteudo .parte .configurar .etapa .nome .icone h3 {
  font-family: var(--medium);
  font-size: var(--f3);
  color: var(--cor-branco);
}
.conteudo .parte .configurar .etapa .nome p {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.conteudo .parte .configurar .etapa .tipos {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.conteudo .parte .configurar .etapa .tipos button {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  background-color: var(--cor-escuro-2);
  padding: 15px;
  margin: 0 0 10px 0;
  border-radius: 8px;
  width: 100%;
  transition: all 0.3s;
}
.conteudo .parte .configurar .etapa .tipos button:hover {
  color: var(--cor-branco);
  background-color: var(--cor-escuro-3);
}
.conteudo .parte .configurar .etapa .tipos button.ativo {
  color: var(--cor-marca);
  background-color: #116cff16;
}
.conteudo .parte .configurar .etapa .campos {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.conteudo .parte .configurar .etapa .campos p {
  font-family: var(--regular);
  font-size: var(--f3);
  color: var(--cor-branco);
  margin: 0 5px;
}
.conteudo .parte .configurar .etapa .tutorial {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  background-color: var(--cor-escuro-2);
  width: 100%;
  border-radius: 8px;
}
.conteudo .parte .configurar .etapa .tutorial p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  margin: 0 0 10px 0;
}
.conteudo .parte .configurar .etapa .tutorial .itens {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.conteudo .parte .configurar .etapa .tutorial .itens .item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  background-color: var(--cor-escuro-3);
  border-radius: 8px;
}
.conteudo .parte .configurar .etapa .tutorial .itens .item:nth-child(1) {
  width: calc(15% - 5px);
}
.conteudo .parte .configurar .etapa .tutorial .itens .item:nth-child(2) {
  width: calc(25% - 5px);
}
.conteudo .parte .configurar .etapa .tutorial .itens .item:nth-child(3) {
  width: calc(28% - 5px);
}
.conteudo .parte .configurar .etapa .tutorial .itens .item:nth-child(4) {
  width: calc(32% - 5px);
}
.conteudo .parte .configurar .etapa .tutorial .itens .item h3 {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
}
.conteudo .parte .configurar .etapa .tutorial .itens .item h4 {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
  margin: 5px 0 0 0;
}
.conteudo .parte .configurar .etapa .aguardar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  background-color: var(--cor-escuro-3);
  border-radius: 8px;
  width: 100%;
}
.conteudo .parte .configurar .etapa .aguardar p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  margin: 0 0 15px 0;
}
.conteudo .parte .configurar .etapa .aguardar .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100px;
  height: 100px;
}
.conteudo .parte .configurar .etapa .aguardar .icone span {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 2px solid var(--cor-marca);
  border-top: 2px solid transparent;
  animation: girando 1s linear infinite;
  position: absolute;
}
.conteudo .parte .configurar .etapa .aguardar .icone h3 {
  font-family: var(--medium);
  font-size: var(--f4);
  color: var(--cor-branco);
}
.conteudo .parte .configurar .etapa .erro {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.conteudo .parte .configurar .etapa .erro p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  margin: 0 0 10px 0;
}
.conteudo .parte .configurar .etapa .erro .possivel {
  display: flex;
  align-items: center;
  margin: 5px 0;
}
.conteudo .parte .configurar .etapa .erro .possivel svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-vermelho);
  margin: 0 5px 0 0;
}
.conteudo .parte .configurar .etapa .erro .possivel h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
}
.conteudo .parte .configurar .sucesso {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.conteudo .parte .configurar .sucesso p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  margin: 0 0 10px 0;
}
.conteudo .parte .configurar .sucesso .link {
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
}
.conteudo .parte .configurar .sucesso .link svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-verde);
  margin: 0 5px 0 0;
}
.conteudo .parte .configurar .sucesso .link h3 {
  font-family: var(--medium);
  font-size: var(--f3);
  color: var(--cor-verde);
}
/* Responsivo */
@media screen and (max-width: 1000px) {
  .opcoes {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: fixed;
    overflow-y: scroll;
    top: -60px;
    left: 0;
    width: 100%;
    height: 60px;
    max-height: 60px;
    border-right: none;
    padding: 0 15px;
    border-bottom: 2px solid var(--cor-escuro-3);
    scrollbar-width: none;
    z-index: 2;
  }
  section.configurar.mostrar .opcoes {
    top: 60px;
  }
  .opcoes::-webkit-scrollbar {
    display: none;
  }
  .opcoes h3 {
    display: none;
  }
  .opcoes button {
    width: fit-content;
    min-width: fit-content;
    padding: 10px;
    margin: 0 5px 0 0;
  }
  .conteudo {
    width: 100%;
    padding: 80px 15px 15px 15px;
  }
  .conteudo .parte {
    padding: 15px;
  }
  .conteudo .parte .tema .imagem span {
    top: 2px;
    left: 5px;
    width: calc(100% - 10px);
    height: 35px;
    border-radius: 15px 15px 0 0;
  }
}
</style>
